import {
  FETCH_STATUS_HISTORY_REQUEST,
  FETCH_STATUS_HISTORY_SUCCESS,
  FETCH_STATUS_HISTORY_FAILURE,
} from "../actions/types";

const initialState = {
  history: [],
  loading: false,
  error: null,
  message: "",
};

export default function statusHistoryReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_STATUS_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_STATUS_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        history: action.payload,
        message: "Status history loaded successfully",
      };

    case FETCH_STATUS_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}

